import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sentry-offline-banner',
    templateUrl: './offline-banner.component.html',
    styleUrls: ['./offline-banner.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class OfflineBannerComponent {}
